export default __webpack_public_path__ + "static/media/Dentec-Training-Logo-White-01.c585ec8e.png";